import React, { useState, useEffect, useContext } from "react";
import awsconfig from "../../aws-exports";
import Amplify, { I18n, Auth, API } from "aws-amplify";
import { CognitoIdentityServiceProvider, AWSError } from "aws-sdk";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import Alert from "react-s-alert";
import AuthGroupWrapper from "../Auth/AuthGroupWrapper";
import { cognitoApi } from "../../api";
const CreateUser = (props) => {
  // const [user, setUser] = useState({})
  const [tempPassword, setTempPassword] = useState("IonSolar123!");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [group, setGroup] = useState("");
  const [admin, setAdmin] = useState("");
  const [newUser, setNewUser] = useState(false);
  // const [users, setUsers] = useState([])

  const { addUserToGroup, userGroups } = props;

  // console.log(userGroups)

  const alertNotification = {
    position: "top-right",
    effect: "flip",
    beep: false,
    timeout: 50000,
    offset: 100,
    color: "rgba(255, 255, 255, 0.927)",
  };

  const createCognitoUser = () => {
    cognitoApi
      .createUser({
        email,
        password: tempPassword,
        first_name: firstName,
        last_name: lastName,
      })
      .then((res) => {
        Alert.success(
          `${firstName} ${lastName} has been created`,
          alertNotification,
          difference.forEach((group) => {
            addUserToGroup(email, group);
          }),
          setNewUser(!newUser)
        );
      })
      .catch((err) => {
        Alert.error(`${err}`, alertNotification);
      });
  };

  const finalGroups = [group, admin];

  var difference = finalGroups.filter(function (el) {
    return el !== "";
  });

  const handleSubmit = (event) => {
    if (difference.length < 1) {
      return Alert.error(`Please select a group`, alertNotification);
    }
    createCognitoUser();
    event.preventDefault();
  };

  const handleChangeDept = (event) => {
    setGroup(event.target.value);
  };
  const handleChangeAdmin = (event) => {
    setAdmin(event.target.value);
  };

  useEffect(() => {
    if (group === "Sales-Rep") {
      setAdmin("");
    }
  }, [group]);

  return (
    <>
      <div style={{ marginBottom: "1rem" }}>
        {newUser ? (
          <>
            <form onSubmit={handleSubmit}>
              <div className="addUser">
                <div className="addItemUser">
                  <TextField
                    required
                    className="input"
                    variant="filled"
                    size="small"
                    margin="dense"
                    label="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                  ></TextField>
                  <TextField
                    required
                    className="input"
                    variant="filled"
                    size="small"
                    margin="dense"
                    label="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                  ></TextField>
                  <TextField
                    required
                    type="email"
                    className="input"
                    variant="filled"
                    size="small"
                    margin="dense"
                    label="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  ></TextField>
                  <span>Temporary Password: {tempPassword}</span>
                </div>

                <div className="addItemUser1">
                  <FormControl fullWidth component="fieldset">
                    <span>Department: </span>
                    <RadioGroup
                      row
                      aria-label="department"
                      name="department"
                      value={group}
                      onChange={handleChangeDept}
                    >
                      <AuthGroupWrapper
                        requiredGroups={["Super-Admin", "Proposals"]}
                      >
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          type="radio"
                          value="Proposals"
                          name="department"
                          label="Proposals"
                        />
                      </AuthGroupWrapper>
                      <AuthGroupWrapper
                        requiredGroups={["Super-Admin", "Sales-Support"]}
                      >
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          type="radio"
                          value="Sales-Support"
                          name="department"
                          label="Sales Support"
                        />
                      </AuthGroupWrapper>
                    </RadioGroup>
                    <RadioGroup
                      row
                      aria-label="department"
                      name="department"
                      value={group}
                      onChange={handleChangeDept}
                    >
                      <AuthGroupWrapper requiredGroups={["Super-Admin", "Ops"]}>
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          type="radio"
                          value="Ops"
                          name="department"
                          label="Operations"
                        />
                      </AuthGroupWrapper>
                      <AuthGroupWrapper
                        requiredGroups={["Super-Admin", "Sales-Support"]}
                      >
                        <FormControlLabel
                          control={<Radio color="primary" />}
                          type="radio"
                          value="Sales-Rep"
                          name="department"
                          label="Sales Rep"
                        />
                      </AuthGroupWrapper>
                    </RadioGroup>
                  </FormControl>
                  {group ? (
                    <>
                      {group === "Proposals" ? (
                        <>
                          <FormControl fullWidth component="fieldset">
                            <span>User Management </span>
                            <RadioGroup
                              row
                              aria-label="admin"
                              name="admin"
                              value={admin}
                              onChange={handleChangeAdmin}
                            >
                              <FormControlLabel
                                control={<Radio color="primary" />}
                                type="radio"
                                value="Super-Admin"
                                name="admin"
                                label="Yes"
                              />
                              <FormControlLabel
                                control={<Radio color="primary" />}
                                type="radio"
                                value=""
                                name="admin"
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </>
                      ) : group === "Sales-Rep" ? (
                        <></>
                      ) : (
                        <FormControl fullWidth component="fieldset">
                          <span>User Management </span>
                          <RadioGroup
                            row
                            aria-label="admin"
                            name="admin"
                            value={admin}
                            onChange={handleChangeAdmin}
                          >
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value="Admin"
                              name="admin"
                              label="Yes"
                            />
                            <FormControlLabel
                              control={<Radio color="primary" />}
                              type="radio"
                              value=""
                              name="admin"
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div>
                <Button
                  style={{
                    color: "rgb(12, 158, 191)",
                    backgroundColor: "rgb(150, 150, 150, .1)",
                    fontSize: "1rem",
                    marginTop: "1rem",
                  }}
                  type="submit"
                >
                  Create New User
                </Button>
              </div>
              <div>
                <Button
                  onClick={() => setNewUser(!newUser)}
                  style={{
                    color: "rgb(12, 158, 191)",
                    backgroundColor: "rgb(150, 150, 150, .1)",
                    fontSize: ".8rem",
                    marginTop: ".8rem",
                  }}
                  type="submit"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </>
        ) : (
          <>
            <Button
              style={{
                color: "rgb(12, 158, 191)",
                backgroundColor: "rgb(150, 150, 150, .1)",
                fontSize: "1rem",
                marginTop: "1rem",
              }}
              onClick={() => setNewUser(!newUser)}
            >
              Add New User
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default CreateUser;
